import React, { useState, useEffect } from 'react';
import { GET_WIFI_POINT_MONITORING_API_URL } from '../../../Optics/OpticApiConfig';

const WifiMonitoringDescription = ({ content }) => {

     const [monitoringData, setMonitoringData] = useState(null); // 🟢 данные из API
     const [loading, setLoading] = useState(false);
     const [refreshing, setRefreshing] = useState(false); // фоновое обновление

     useEffect(() => {
  loadMonitoringData(false); // первая загрузка

  const interval = setInterval(() => {
    loadMonitoringData(true); // фоновое обновление
  }, 5000);

  return () => clearInterval(interval);
}, [content.ip]);

const loadMonitoringData = async (isRefresh = false) => {
  if (!content.ip) return;

  try {
    if (!isRefresh && !monitoringData) {
      setLoading(true);        // первый вход
    } else {
      setRefreshing(true);     // автообновление
    }

    const response = await fetch(
      `${GET_WIFI_POINT_MONITORING_API_URL}?ip=${content.ip}`
    );
    // если данных нет
    if (response.status === 204) {
      setMonitoringData(null);
      return;
    }

    if (!response.ok) {
      throw new Error("Ошибка при загрузке данных");
    }

    const data = await response.json();
    setMonitoringData(data);

  } catch (error) {
    //console.error("Ошибка при получении мониторинга:", error);
  } finally {
    setLoading(false);
    setRefreshing(false);
  }
};

  //     // ⏱ Автообновление каждые 10 секунд
  //     useEffect(() => {
  //       loadMonitoringData();
  //       const interval = setInterval(loadMonitoringData, 1000); // 1 секунд
  //       return () => clearInterval(interval);
  //     }, []);

  //      // 🔄 Функция загрузки данных
  // const loadMonitoringData = async () => {
  //   if (!content.ip) return;
  //   try {
  //     setLoading(true);
  //     const response = await fetch(
  //       `${GET_WIFI_POINT_MONITORING_API_URL}?ip=${content.ip}`
  //     );
  //     if (!response.ok) throw new Error("Ошибка при загрузке данных");
  //     const data = await response.json();
  //     setMonitoringData(data);
  //   } catch (error) {
  //     console.error("Ошибка при получении мониторинга:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

    const getColor = (label, value) => {
  if (value === undefined || value === null || value === "") return "#d1d1d1";

  switch (label) {
    // --- Радио ---
    case "Сигнал":
    case "RSSI":
      if (value > -60) return "#95e29bff"; // отлично
      if (value >= -75) return "khaki";    // допустимо
      return "#ee9797ff";                  // критично

    case "Шум":
      if (value > -90) return "#95e29bff";
      if (value >= -100) return "khaki";
      return "#ee9797ff";

    case "CCQ":
      if (value > 90) return "#95e29bff";
      if (value >= 70) return "khaki";
      return "#ee9797ff";

    // --- Система ---
    case "CPU загрузка":
      if (value < 60) return "#95e29bff";
      if (value < 85) return "khaki";
      return "#ee9797ff";

    case "Температура":
      if (value < 60) return "#95e29bff";
      if (value < 75) return "khaki";
      return "#ee9797ff";

    case "Свободная память":
      if (value > 20) return "#95e29bff"; // МБ
      if (value > 10) return "khaki";
      return "#ee9797ff";

    // case "Загрузка канала":
    //   // if (value < 70) return "limegreen";
    //   // if (value < 90) return "khaki";
    //   return "orangered";

    // case "Скорость":
    //   return value < 0 ? "limegreen" : "orangered";

    default:
      return "#f0f0f0ff";
  }
};



    const Info = ({ label, value }) => {
    let numericValue = parseFloat(value);
    const displayColor = getColor(label, numericValue);

    return (
      <div style={{ marginBottom: "4px",  whiteSpace: "nowrap" }}>
        <span style={{ color: "#181818ff", fontWeight: 'bold'}}>{label}: </span>
        <span style={{ color: displayColor, textShadow: "1px 1px 2px #000000ff" }}>
          {value !== undefined && value !== null && value !== "" ? value : "-"}
        </span>
      </div>
    );
  };

  return (
    <div
      className="divCommunicationsDrawer"
      style={{
        flex: 1,
        minWidth: "220px", 
        border: "1px solid #ffea97ff",
        borderRadius: "20px",
        padding: "10px",
        marginTop: '10px',
        fontSize: "14px",
        background: "linear-gradient(to bottom,   #292929ff, #353535ff)",
      }}
    >
      {loading ? (
        <div className="nodata-container" >
        <div className="loader"></div>
        <p className="loader-text">Загрузка...</p>
  </div>
      ) : monitoringData ? (
        <>
          
   
          {/* Окно антенны */}
          <label style={{ color: "#ffea97ff", marginBottom: "2px", textShadow: "1px 1px 2px #000000ff", fontSize: '18px' }}>Показатели антенны</label>
          <hr className='hr-gradient' style={{marginBottom: '5px'}}/>

          <div style={{ display: "grid", gap: "10px" }}>
            {/* Общая инфа */}
            <div className="infoCard" style={{ display: "block", boxShadow: "0px 0px 6px 0px #000000ff" }}>
              <label style={{ color: "#dcc875ff", marginBottom: "0px", textShadow: "1px 1px 2px #000000ff", fontSize: '18px'}}>Общая информация</label>
              <hr className='hr-gradient'/>

              <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>IP:</span><span style={{textShadow: "1px 1px 2px #000000ff", color:'#f0f0f0ff'}}> {monitoringData.ip}</span></div>
              <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>MAC:</span><span style={{textShadow: "1px 1px 2px #000000ff", color:'#f0f0f0ff'}}> {monitoringData.mac}</span></div>
              <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>Модель:</span><span style={{textShadow: "1px 1px 2px #000000ff", color:'#f0f0f0ff'}}> {monitoringData.model}</span></div>
              <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>Имя устройства:</span><span style={{textShadow: "1px 1px 2px #000000ff", color:'#f0f0f0ff'}}> {monitoringData.hostname}</span></div>
              <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>Прошивка:</span><span style={{textShadow: "1px 1px 2px #000000ff", color:'#f0f0f0ff'}}> {monitoringData.firmware}</span></div>
            </div>
          </div>

          {/* СИСТЕМА */}
           <div className="infoCard" style={{ display: "block", marginTop: '5px', boxShadow: "0px 0px 6px 0px #000000ff" }}>
               <label style={{ color: "#dcc875ff", marginBottom: "0px", textShadow: "1px 1px 2px #000000ff", fontSize: '18px'}}>Система</label>
              <hr className='hr-gradient'/>

              <Info label="Аптайм" value={monitoringData.upTime} />

              <Info
                label="CPU загрузка"
                value={`${parseFloat(monitoringData.cpuLoad || 0).toFixed(1)} %`}
              />

              <Info
                 label="Память (свободно/всего)"
                 value={`${parseFloat(monitoringData.freeRam || 0)} / ${parseFloat(monitoringData.totalRam || 0)} МБ`}
              />
            {content.wifiModelVendorId != 2  ? (
              <Info
                  label="Температура"
                  value={`${parseFloat(monitoringData.temperature || 0).toFixed(1)} °C`}
                />
             ) : null}
             
            </div>
         
          {/* РАДИО */}
         <div className="infoCard" style={{ display: "block", boxShadow: "0px 0px 6px 0px #000000ff", marginTop: '5px' }}>
              <label style={{ color: "#dcc875ff", marginBottom: "0px", textShadow: "1px 1px 2px #000000ff", fontSize: '18px'}}>Радио</label>
              <hr className='hr-gradient'/>

          <div >
            <div className="monitoring-grid">
            <Info label="SSID" value={monitoringData.ssid} />

              {content.wifiModelVendorId != 2  ? (
                <>
                  <Info label="Режим" value={monitoringData.mode} />
                  <Info label="Частота" value={`${monitoringData.frequency} МГц`} />
                
                  <Info
                    label="Ширина канала"
                    value={`${monitoringData.chanbw} МГц`}
                  />
                  <Info
                    label="Мощность"
                    value={`${monitoringData.txPower} dBm`}
                  />
                </>
              ) : null}
            <Info
              label="Сигнал"
              value={`${parseFloat(monitoringData.signal)} dBm`}
            />

             {content.wifiModelVendorId != 2  ? (
              <>
                <Info
                  label="RSSI"
                  value={`${parseFloat(monitoringData.rssi)} dBm`}
                />
                <Info
                  label="CCQ"
                  //value={`${parseFloat(monitoringData.ccq).toFixed(1)} %`}
                    value={`${(parseFloat(monitoringData.ccq) / 10).toFixed(1)} %`}
                />
              </>
            ) : null}
            </div>

             {content.wifiModelVendorId != 2  ? (
                <Info
                  label="Соотношение сигнал/шум"
                  value={`TX=${monitoringData.txCinr} дБ, RX=${monitoringData.rxCinr} дБ`}
                />
             ) : null}
          </div>
          </div>

          {/* КЛИЕНТСКОЕ СОЕДИНЕНИЕ */}
          <div className="infoCard" style={{ display: "block", boxShadow: "0px 0px 6px 0px #000000ff", marginTop: '5px' }}>
               <label style={{ color: "#dcc875ff", marginBottom: "0px", textShadow: "1px 1px 2px #000000ff", fontSize: '18px'}}>Клиентское соединение</label>
              <hr className='hr-gradient'/>
          

          <div style={{ marginBottom: "10px" }}>
            <Info
              label="Скорость"
              value={`TX=${monitoringData.txRate}, RX=${monitoringData.rxRate} Мбит/с`}
            />

          {content.wifiModelVendorId != 2  ? (
            <>
                <Info label="Расстояние" value={`${monitoringData.distance || 0} м`} />

                <Info
                  label="Загрузка канала"
                  value={`TX=${monitoringData.txUsage}, RX=${monitoringData.rxUsage} Мбит/с`}
                />

                <Info
                  label="Пропускная способность"
                  value={`TX=${monitoringData.txThroughput}, RX=${monitoringData.rxThroughput} кбит/с`}
                />
            </>
          ) : null} 

          </div>
          </div>

          {/* Дата */}
         <div className="info-row">
            <div className="info-icon">
              📅
            </div>
            <div className="info-content">
              <span className="info-label">Последний опрос:</span>
              <span className="info-value">
                  {new Date(monitoringData.date)
                    .toISOString()
                    .slice(0, 19)
                    .replace("T", " ")
                    .replace(/-/g, ".")}
                </span>
            </div>
          </div>
        </>
      ) : (
          <div className="nodata-container">
    <div className="nodata-pulse"></div>
    <p className="nodata-text">Нет данных мониторинга</p>
  </div>
      )}
    </div>
  );
};

export default WifiMonitoringDescription;